import type { Cell, Unit } from '@/game/sim';

/** How long a move click shows its marker without the host confirming it (ms). */
export const PENDING_MOVE_MS = 1000;

/**
 * A move order just clicked, shown at once on this client only: the host's
 * snapshot with the real order takes a round trip plus a tick to arrive.
 */
export interface PendingMove {
  cell: Cell;
  unitIds: readonly string[];
  /** `Date.now()` when clicked. */
  at: number;
}

/**
 * Whether the pending marker can go: it timed out, or a snapshot now shows
 * the order on one of its units (the real marker takes over from there).
 */
export function pendingMoveDone(
  pending: PendingMove,
  units: Readonly<Record<string, Unit>>,
  now: number
): boolean {
  if (now - pending.at >= PENDING_MOVE_MS) return true;
  return pending.unitIds.some((id) => {
    const order = units[id]?.order;
    return (
      (order?.kind === 'move' || order?.kind === 'attackMove') &&
      order.target.q === pending.cell.q &&
      order.target.r === pending.cell.r
    );
  });
}
